import tw from "tailwind-styled-components";
import { CheckIcon, LinkIcon } from "@heroicons/react/20/solid";
import { ShoppingCartIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { useCollections } from "./hooks/useCollections";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const defaultCollectionName = "Untitled Collection";
export function CollectionDetails(_ref) {
  var _collections$data, _collection$name;
  let {
    collection,
    projectsInView,
    onAddAllApplicationsToCart
  } = _ref;
  const collections = useCollections();

  // filter collections by collection.href
  const description = (_collections$data = collections.data) === null || _collections$data === void 0 || (_collections$data = _collections$data.find(c => c.cid && location.href.includes(c.cid))) === null || _collections$data === void 0 ? void 0 : _collections$data.description;
  return /*#__PURE__*/_jsx("div", {
    className: "mt-16",
    children: /*#__PURE__*/_jsxs("div", {
      className: "grid grid-cols-1 md:grid-cols-4 gap-12",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "col-span-1 md:col-span-4 flex flex-col md:flex-row justify-between items-start md:items-center",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "text-4xl font-medium",
          children: `${(_collection$name = collection.name) !== null && _collection$name !== void 0 ? _collection$name : defaultCollectionName} (${projectsInView})`
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex gap-2 mt-4 md:mt-0",
          children: [/*#__PURE__*/_jsx(ShareButton, {
            url: location.href
          }), /*#__PURE__*/_jsx(AddToCartButton, {
            current: projectsInView,
            total: collection.applications.length,
            onAdd: onAddAllApplicationsToCart
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "col-span-1 md:col-span-3 text-lg flex-1 whitespace-pre-wrap",
        children: description !== null && description !== void 0 ? description : collection.description
      })]
    })
  });
}
const AddToCartButton = _ref2 => {
  let {
    current,
    total,
    onAdd
  } = _ref2;
  const [isAdded, setAdded] = useState(false);
  const Icon = isAdded ? CheckIcon : ShoppingCartIcon;
  return /*#__PURE__*/_jsxs(Button, {
    className: "",
    disabled: isAdded,
    onClick: () => {
      onAdd();
      setAdded(true);
    },
    children: [/*#__PURE__*/_jsx(Icon, {
      className: "w-4 h-4"
    }), isAdded ? "Added" : `Add all to cart (${current}/${total})`]
  });
};
const ShareButton = _ref3 => {
  let {
    url = ""
  } = _ref3;
  const [isCopied, setCopied] = useState(false);
  const Icon = isCopied ? CheckIcon : LinkIcon;
  return /*#__PURE__*/_jsxs(Button, {
    variant: "primary",
    disabled: isCopied,
    onClick: () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
      navigator.clipboard.writeText(url);
    },
    children: [/*#__PURE__*/_jsx(Icon, {
      className: "w-4 h-4"
    }), isCopied ? "Copied" : "Share"]
  });
};

// These buttons are very different from the old GS designs.
// Keeping it here for now until other designs with these kinds of buttons.
const variantMap = {
  default: "bg-white hover:bg-grey-100",
  translucent: "bg-white/60 hover:bg-white/80 border-white border",
  primary: "bg-orange-100 hover:bg-orange-50"
};
export const Button = tw.button`
border-grey-100
disabled:pointer-events-none
px-3 py-2
text-sm
font-medium
rounded-lg
whitespace-nowrap
inline-flex gap-1
items-center
transition-colors
${_ref4 => {
  let {
    variant = "default"
  } = _ref4;
  return variant && variantMap[variant];
}}
`;